import style from './PreviewBar.module.scss';

export default function Preview() {
    return (
        <div className={style.Preview}>
            <p>You are currently in Preview Mode.</p>
        </div>
    );
}
